import { Accordion, AccordionDetails, AccordionSummary, Chip, Divider, Grid } from "@mui/material";
import { GridExpandMoreIcon } from "@mui/x-data-grid";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

import styles from "../../../../../assets/styles/componentStyles/templateLibraryStyles/modifyWhatsAppTemplate/whatsAppTemplateForm.module.scss";

import { useTemplateLibraryStore } from "../../../../../store/templateLibraryStore";
import Required from "../../../../utility/required";
import { createWhatsappTemplatePayloadForTemplateLibrary } from "../../../../../models/axiosModel";
import { getTooltipTextOfTypeOfVariable, isTemplateCategoryAuthentication, TYPE_OF_VARIABLE, TYPE_OF_VARIABLE_OPTIONS } from "../../../channels/global/whatsapp/templates/utils";
import { useCarouselFunctions } from "../../utils/useCarouselFunctions";
import TouchTooltip from "../../utils/TouchTooltip";

function WhatsAppTemplateFormTypeOfVariable() {

    const createTemplatePayload = useTemplateLibraryStore((state) => state.createTemplatePayload);
    const setCreateTemplatePayload = useTemplateLibraryStore((state) => state.setCreateTemplatePayload);
    const templateLibraryCategoryList = useTemplateLibraryStore((state) => state.templateLibraryCategoryList);

    const { isMobileScreen } = useCarouselFunctions();

    const onChangeOfTypeOfVariable = (value: string) => {
        setCreateTemplatePayload({
            ...createTemplatePayload,
            flag_named_parameter: value === TYPE_OF_VARIABLE['NAME'] ? true : false,
        } as createWhatsappTemplatePayloadForTemplateLibrary);
    }

    const isAuthenticationTemplate = isTemplateCategoryAuthentication(templateLibraryCategoryList, createTemplatePayload?.whatsapp_template_data?.whatsapp_template_category_id);
    const isDisabled = Boolean(createTemplatePayload?.whatsapp_template_id || isAuthenticationTemplate);
    const selectedType = createTemplatePayload?.flag_named_parameter ? TYPE_OF_VARIABLE['NAME'] : TYPE_OF_VARIABLE['NUMBER'];

    return (
        <>
            <Accordion defaultExpanded={true} className={`${styles.accordion}`}>
                <AccordionSummary expandIcon={<GridExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header" className={styles.accordion__summary}>
                    <Grid container alignItems="center" justifyContent="flex-start" flexWrap="nowrap" gap={1}>
                        <span className={styles.accordion__summary__text}>
                            Type of variable <Required />
                        </span>

                        {!isAuthenticationTemplate && (
                            <TouchTooltip
                                title={getTooltipTextOfTypeOfVariable()}
                                placement={isMobileScreen ? 'top-start' : 'right'}
                            >
                                <InfoOutlinedIcon className={styles.formInfoIconLarge} />
                            </TouchTooltip>
                        )}
                    </Grid>
                </AccordionSummary>

                <Divider sx={{ width: "100%", opacity: "1" }} />


                <AccordionDetails className={styles.accordion__details}>
                    
                    <Grid item xs={12} role="listbox" aria-label="Type of variable" className={`${styles.typeOfVariableChips} ${isDisabled ? styles['typeOfVariableChips--disabled'] : ''}`}>
                        {TYPE_OF_VARIABLE_OPTIONS?.map((type: string) => {
                            const isSelected = selectedType === type;
                            return (
                                <Chip
                                    key={type}
                                    size="small"
                                    label={type}
                                    role="option"
                                    aria-selected={isSelected}
                                    clickable={!isDisabled}
                                    disabled={isDisabled}
                                    onClick={() => !isDisabled && onChangeOfTypeOfVariable(type)}
                                    className={`${styles.typeOfVariableChip} ${isSelected ? styles['typeOfVariableChip--selected'] : ''}`}
                                />
                            );
                        })}
                    </Grid>

                </AccordionDetails>
            </Accordion>

        </>
    );
}

export default WhatsAppTemplateFormTypeOfVariable;